(function() {
	PM.JiraIntegration = {};

	PM.JiraIntegration.initMappingChoices = function($row) {
		$row.find('.js-choices-pmanager, .js-choices-jira').each(function() {
			var $el = $(this);
			if ($el.data('choices-instance')) return;
			setTimeout(function() {
				new Choices($el[0], {
					searchEnabled: true,
					shouldSort: true,
					addItems: false,
					removeItemButton: false,
					noResultsText: i18next.t('No results found'),
					noChoicesText: i18next.t('No options available'),
					itemSelectText: '',
					allowHTML: false
				});
			}, 0);
		});
	};

	PM.JiraIntegration.renderLog = function() {
		$.get('/api/logs?source=jira&limit=50').done(function(entries) {
			var $panel = $('.js-jira-log-panel');
			var $list = $panel.find('.js-jira-log-entries');
			$list.empty();

			if (entries.length === 0) return;

			$panel.show();

			for (var i = 0; i < entries.length; i++) {
				var entry = entries[i];
				var badgeClass = entry.level === 'error' ? 'bg-danger' : entry.level === 'warn' ? 'bg-warning text-dark' : 'bg-secondary';
				var time = new Date(entry.createdAt).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', second: '2-digit' });
				var $item = $('<div class="list-group-item py-1 px-2 d-flex align-items-start gap-2"></div>');
				$item.append('<small class="text-muted text-nowrap">' + time + '</small>');
				$item.append('<span class="badge ' + badgeClass + ' text-nowrap" style="font-size:0.7rem;">' + entry.level + '</span>');
				$item.append('<span>' + entry.message + '</span>');
				$list.append($item);
			}
		});
	};

	PM.JiraIntegration.renderSection = function() {
		if (!PM.Shell.checkFeature('jira')) {
			PM.JiraIntegration._renderUpgrade();
			return;
		}
		$.when(
			$.get('/api/integrations/jira'),
			$.get('/api/integrations/jira/projects'),
			$.get('/api/integrations/jira/people'),
			ejs.preloadTemplate('/app/config/integrations/jira/templates/jira.ejs'),
			ejs.preloadTemplate('/app/config/integrations/jira/templates/mapping-row.ejs')
		).done(function(jiraResult, projectMappingsResult, peopleMappingsResult) {
			var data = jiraResult[0];
			var jira = data.jira;
			var pmanagerProjects = data.pmanagerProjects || [];
			var pmanagerPeople = data.pmanagerPeople || [];
			var projectMappings = projectMappingsResult[0];
			var peopleMappings = peopleMappingsResult[0];

			var mappedProjectIds = new Set(projectMappings.map(function(m) { return m.projectsId; }));
			var availableProjects = pmanagerProjects.filter(function(p) { return !mappedProjectIds.has(Number(p.id)); });
			PM.JiraIntegration._availableProjects = availableProjects;

			var mappedPeopleIds = new Set(peopleMappings.map(function(m) { return m.peopleId; }));
			var availablePeople = pmanagerPeople.filter(function(p) { return !mappedPeopleIds.has(Number(p.id)); });
			PM.JiraIntegration._availablePeople = availablePeople;

			var contentHtml = ejs.rr('/app/config/integrations/jira/templates/jira.ejs', {
				jira: jira,
				projectMappings: projectMappings,
				peopleMappings: peopleMappings,
				pmanagerProjects: pmanagerProjects,
				pmanagerPeople: pmanagerPeople,
				availableProjects: availableProjects,
				availablePeople: availablePeople
			});
			PM.Config.renderSection('integrations/jira', contentHtml);
			PM.JiraIntegration.renderLog();
		});
	};

	PM.JiraIntegration.render = function() {
		if (!PM.Shell.checkFeature('jira')) {
			PM.JiraIntegration._renderUpgrade();
			return;
		}
		$.when(
			$.get('/api/integrations/jira'),
			$.get('/api/integrations/jira/projects'),
			$.get('/api/integrations/jira/people'),
			ejs.preloadTemplate('/app/config/integrations/jira/templates/jira.ejs'),
			ejs.preloadTemplate('/app/config/integrations/jira/templates/mapping-row.ejs')
		).done(function(jiraResult, projectMappingsResult, peopleMappingsResult) {
			var data = jiraResult[0];
			var jira = data.jira;
			var pmanagerProjects = data.pmanagerProjects || [];
			var pmanagerPeople = data.pmanagerPeople || [];
			var projectMappings = projectMappingsResult[0];
			var peopleMappings = peopleMappingsResult[0];

			var mappedProjectIds = new Set(projectMappings.map(function(m) { return m.projectsId; }));
			var availableProjects = pmanagerProjects.filter(function(p) { return !mappedProjectIds.has(Number(p.id)); });
			PM.JiraIntegration._availableProjects = availableProjects;

			var mappedPeopleIds = new Set(peopleMappings.map(function(m) { return m.peopleId; }));
			var availablePeople = pmanagerPeople.filter(function(p) { return !mappedPeopleIds.has(Number(p.id)); });
			PM.JiraIntegration._availablePeople = availablePeople;

			var contentHtml = ejs.rr('/app/config/integrations/jira/templates/jira.ejs', {
				jira: jira,
				projectMappings: projectMappings,
				peopleMappings: peopleMappings,
				pmanagerProjects: pmanagerProjects,
				pmanagerPeople: pmanagerPeople,
				availableProjects: availableProjects,
				availablePeople: availablePeople
			});
			$('.js-page-container').html(contentHtml);
			PM.JiraIntegration.renderLog();
		});
	};

	$(document).on('click', '.js-jira-enabled', function() {
		$('.js-jira-config-form').submit();
	});

	$(document).on('submit', '.js-jira-config-form', function(e) {
		e.preventDefault();
		var url = $(this).find('.js-jira-url').val().trim();
		var email = $(this).find('.js-jira-email').val().trim();
		var apiToken = $(this).find('.js-jira-api-token').val().trim();

		if (!url || !email || !apiToken) {
			new Notify({ status: 'error', text: i18next.t('Please fill in all three fields: Jira URL, email, and API token.'), timeout: 3000 });
			$('.js-jira-enabled').prop('checked', false);
			return;
		}

		var data = {
			url: url,
			email: email,
			api_token: apiToken,
			enabled: $(this).find('.js-jira-enabled').is(':checked')
		};
		$.ajax({
			url: '/api/integrations/jira',
			method: 'PUT',
			contentType: 'application/json',
			data: JSON.stringify(data)
		}).done(function() {
			PM.JiraIntegration.render();
		});
	});

	$(document).on('click', '.js-jira-disconnect', function() {
		if (!confirm(i18next.t('Disconnect Jira integration? This will remove all mappings and imported data.'))) return;
		$.ajax({
			url: '/api/integrations/jira',
			method: 'DELETE'
		}).done(function() {
			PM.JiraIntegration.render();
		});
	});

	$(document).on('click', '.js-add-project-mapping', function() {
		var $btn = $(this);
		var originalHtml = $btn.html();
		$btn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ' + i18next.t('Loading...'));

		$.get('/api/integrations/jira/projects/available')
			.done(function(jiraProjects) {
				var html = ejs.rr('/app/config/integrations/jira/templates/mapping-row.ejs', {
					type: 'project',
					pmanagerOptions: PM.JiraIntegration._availableProjects || []
				});

				var $row = $(html);

				jiraProjects.forEach(function(jp) {
					$row.find('.js-jira-project-select').append('<option value="' + jp.key + '">' + jp.key + ' - ' + jp.name + '</option>');
				});

				var $tbody = $('.js-project-mappings-tbody');
				if ($tbody.find('.js-no-project-mappings').length) {
					$tbody.empty();
				}
				$tbody.prepend($row);

				PM.JiraIntegration.initMappingChoices($row);
			})
			.always(function() {
				$btn.prop('disabled', false).html(originalHtml);
			});
	});

	$(document).on('click', '.js-save-project-mapping', function() {
		var $row = $(this).closest('tr');
		var projectsId = parseInt($row.find('.js-pmanager-project-select').val(), 10);
		var jiraProjectKey = $row.find('.js-jira-project-select').val();
		if (!projectsId || !jiraProjectKey) return;

		$.ajax({
			url: '/api/integrations/jira/projects',
			method: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({ projectsId: projectsId, jiraProjectKey: jiraProjectKey })
		}).done(function() {
			PM.JiraIntegration.render();
		});
	});

	$(document).on('click', '.js-cancel-project-mapping', function() {
		$(this).closest('tr').remove();
	});

	$(document).on('click', '.js-remove-project-mapping', function() {
		var id = $(this).closest('tr').data('id');
		if (!confirm(i18next.t('Remove this project mapping?'))) return;
		$.ajax({
			url: '/api/integrations/jira/projects/' + id,
			method: 'DELETE'
		}).done(function() {
			PM.JiraIntegration.render();
		});
	});

	$(document).on('click', '.js-add-person-mapping', function() {
		var $btn = $(this);
		var originalHtml = $btn.html();
		$btn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ' + i18next.t('Loading...'));

		$.get('/api/integrations/jira/people/available')
			.done(function(jiraUsers) {
				var html = ejs.rr('/app/config/integrations/jira/templates/mapping-row.ejs', {
					type: 'person',
					pmanagerOptions: PM.JiraIntegration._availablePeople || []
				});

				var $row = $(html);

				jiraUsers.forEach(function(ju) {
					$row.find('.js-jira-person-select').append('<option value="' + ju.accountId + '">' + ju.displayName + ' (' + ju.accountId + ')</option>');
				});

				var $tbody = $('.js-people-mappings-tbody');
				if ($tbody.find('.js-no-people-mappings').length) {
					$tbody.empty();
				}
				$tbody.prepend($row);

				PM.JiraIntegration.initMappingChoices($row);
			})
			.fail(function() {
				new Notify({ status: 'error', text: 'Failed to load Jira users.', timeout: 3000 });
			})
			.always(function() {
				$btn.prop('disabled', false).html(originalHtml);
			});
	});

	$(document).on('click', '.js-save-person-mapping', function() {
		var $row = $(this).closest('tr');
		var peopleId = parseInt($row.find('.js-pmanager-person-select').val(), 10);
		var jiraAccountId = $row.find('.js-jira-person-select').val();
		var jiraDisplayName = $row.find('.js-jira-person-select option:selected').text().replace(/ \(.*\)$/, '');
		if (!peopleId || !jiraAccountId) return;

		$.ajax({
			url: '/api/integrations/jira/people',
			method: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({ peopleId: peopleId, jiraAccountId: jiraAccountId, jiraDisplayName: jiraDisplayName })
		}).done(function() {
			PM.JiraIntegration.render();
		});
	});

	$(document).on('click', '.js-cancel-person-mapping', function() {
		$(this).closest('tr').remove();
	});

	$(document).on('click', '.js-remove-person-mapping', function() {
		var id = $(this).closest('tr').data('id');
		if (!confirm(i18next.t('Remove this people mapping?'))) return;
		$.ajax({
			url: '/api/integrations/jira/people/' + id,
			method: 'DELETE'
		}).done(function() {
			PM.JiraIntegration.render();
		});
	});

	$(document).on('click', '.js-jira-import-btn', function() {
		if (!$('.js-jira-enabled').is(':checked')) {
			new Notify({ status: 'warning', text: i18next.t('Jira integration is disabled. Enable it first.'), timeout: 3000 });
			return;
		}
		var $btn = $(this);
		var $status = $('.js-jira-import-status');
		$btn.prop('disabled', true);
		$status.text(i18next.t('Importing...')).show();

		$.ajax({
			url: '/api/integrations/jira/import',
			method: 'POST'
		}).done(function(data) {
			$status.text(i18next.t('Imported') + ' ' + data.total + ', ' + i18next.t('skipped') + ' ' + data.skipped);
			PM.JiraIntegration.renderLog();
		}).fail(function() {
			$status.text(i18next.t('Import failed'));
			PM.JiraIntegration.renderLog();
		}).always(function() {
			$btn.prop('disabled', false);
		});
	});

	$(document).on('click', '.js-log-refresh', function() {
		PM.JiraIntegration.renderLog();
	});

	PM.JiraIntegration._renderUpgrade = function() {
		ejs.preloadTemplate('/app/shell/templates/upgrade-required.ejs').then(function() {
			var html = ejs.rr('/app/shell/templates/upgrade-required.ejs', {});
			PM.Config.renderSection('integrations/jira', html);
		});
	};
})();
